import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

// Initial state
const initialState = {
  filters: {
    modalFiltersRules: undefined,
    modalConditions: undefined,
  },
};
// Actual Slice
export const arnmAccidentsSlice = createSlice({
  name: 'arnmAccidents',
  initialState,
  reducers: {
    filtersModalConditionArnmAccidentsChangeSuccess: (state, { payload }) => {
      state.filters.modalConditions = payload;
      if (!payload?.rules?.length) {
        state.filters.modalFiltersRules = undefined;
      }
    },
    filtersModalRulesArnmAccidentsChangeSuccess: (state, { payload }) => {
      state.filters.modalFiltersRules = payload;
    },
    resetModalArnmAccidentsChangeSuccess: (state) => {
      state.filters.modalConditions = null;
      state.filters.modalFiltersRules = null;
    },
  },
  // Special reducer for hydrating the state. Special case for next-redux-wrapper
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.errors,
      };
    },
  },
});

export const {
  filtersModalConditionArnmAccidentsChangeSuccess,
  filtersModalRulesArnmAccidentsChangeSuccess,
  resetModalArnmAccidentsChangeSuccess,
} = arnmAccidentsSlice.actions;

export const selectArnmAccidentsState = (state) => state.arnmAccidents;

export default arnmAccidentsSlice.reducer;

export const filtersModalConditionArnmAccidentsChange = (conditions) => {
  return (dispatch) => {
    dispatch(filtersModalConditionArnmAccidentsChangeSuccess(conditions));
  };
};
export const filtersModalRulesArnmAccidentsChange = (rules) => {
  // console.log(rules);
  return (dispatch) => {
    dispatch(filtersModalRulesArnmAccidentsChangeSuccess(rules));
  };
};
export const resetModalArnmAccidentsChange = () => {
  return (dispatch) => {
    dispatch(resetModalArnmAccidentsChangeSuccess());
  };
};
